import { INITIAL_LANGUAGE } from 'const';
import { createStore } from 'effector';
import { Language } from 'models';

export const $language = createStore<Language>(INITIAL_LANGUAGE);
